import type { FC, ReactNode } from 'react'
import type { MotionValue } from 'motion/react'

import { motion } from 'motion/react'
import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StarBurstProps {
    rotate?: MotionValue<number>
    className?: string
}

const POINTS = Array.from({ length: 24 }, (_, index) => {
    const angle = (index * Math.PI) / 12 - Math.PI / 2
    const radius = index % 2 === 0 ? 50 : 41

    return `${(50 + radius * Math.cos(angle)).toFixed(2)},${(50 + radius * Math.sin(angle)).toFixed(2)}`
}).join(' ')

// A sticker-style rating badge. Purely decorative: the rating is also written out next to the buttons.
const StarBurst: FC<StarBurstProps> = ({ rotate, className }): ReactNode => {
    return (
        <div aria-hidden='true' className={cn('relative size-24 sm:size-28', className)}>
            <motion.div style={rotate ? { rotate } : undefined} className='absolute inset-0'>
                <svg viewBox='0 0 100 100' className='size-full animate-spin-slow overflow-visible'>
                    <polygon points={POINTS} className='fill-ink' />
                </svg>
            </motion.div>

            <div className='absolute inset-0 grid place-content-center text-center text-paper'>
                <span className='font-heading text-2xl font-extrabold leading-none tracking-[-0.02em] sm:text-3xl'>
                    5.0
                </span>

                <span className='mt-1 flex justify-center gap-0.5'>
                    {[0, 1, 2, 3, 4].map(index => (
                        <Star key={index} className='size-2.5 fill-blaze text-blaze' />
                    ))}
                </span>
            </div>
        </div>
    )
}

export default StarBurst
